import type { IItem, IRelatedProducts, RelatedProductItem } from '@/types/IOrder'

export const formatRelatedProducts = (
  relatedProducts: IRelatedProducts[] | undefined
): RelatedProductItem[] => {
  if (!relatedProducts) return []

  return relatedProducts.map((relatedProduct) => {
    const product = {
      uuid: relatedProduct.uuid,
      name: relatedProduct.name
    }

    const items = (relatedProduct.items ?? []).map((item: IItem) => ({
      item: item,
      uuid: item.uuid,
      current: item.min
    }))

    return {
      product,
      items,
      pivot: relatedProduct.pivot,
    }
  })
}

